module.exports = __webpack_public_path__ + "img/base.8ced6bd0.png";